import {
  AnswerOptionUpdateInput,
  QuestionCategory,
  ScaleQuestionUpdateInput,
  TestResultUpdateInput,
  TestVersionCreateInput,
  TestVersionUpdateInput,
} from "../../api";
import { builder } from "../builder";

const AnswerOptionUpdate = builder.input<AnswerOptionUpdateInput>("AnswerOptionUpdateInput", {
  _destroy: builder.boolean(),
  text: builder.string(),
  id: builder.string().uuid(),
  points: builder.number(),
  order: builder.number(),
});

const ScaleQuestionUpdate = builder.input<ScaleQuestionUpdateInput>("ScaleQuestionUpdateInput", {
  _destroy: builder.boolean(),
  id: builder.string().uuid(),
  text: builder.string(),
  order: builder.number(),
  reverseScoring: builder.boolean(),
  category: builder.string().oneOf(Object.values(QuestionCategory)).nullable(),
});

const TestResultUpdate = builder.input<TestResultUpdateInput>("TestResultUpdateInput", {
  _destroy: builder.boolean(),
  id: builder.string().uuid(),
  title: builder.string(),
  description: builder.string(),
  minPoints: builder.number(),
  maxPoints: builder.number(),
  image: builder.string().uuid(),
});

builder.input<TestVersionUpdateInput>("TestVersionUpdateInput", {
  answers: builder.array().of(AnswerOptionUpdate).nullable(),
  questions: builder.array().of(ScaleQuestionUpdate).nullable(),
  results: builder.array().of(TestResultUpdate).nullable(),
  description: builder.string().nullable(),
  name: builder.string().nullable(),
});

builder.input<TestVersionCreateInput>("TestVersionCreateInput", {
  name: builder.string(),
  testDefinitionId: builder.string().uuid(),
});
